<template>
  <container-slot>
    <!-- News Card -->
    <v-col cols="12">
      <v-card color="#6fbee2" dark elevation="5">
        <v-card-title class="headline font-weight-medium">News</v-card-title>
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerNews"
            :items="listNews"
            :items-per-page="5"
            :loading="$apollo.queries.listNews.loading"
          >
            <!-- Customizing headers news -->
            <template v-slot:header.no="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.id="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.title="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.createdAt="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.author="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <!-- End customizing headers news -->

            <template v-slot:body="props">
              <tbody>
                <template v-if="props.items.length">
                  <tr v-for="news in props.items" :key="`news-${news.id}`">
                    <td
                      v-for="(header, i) in headerNews"
                      :key="`headerNews-${i}`"
                    >
                      {{ tdValue(news[header.field], header.field) }}
                    </td>
                  </tr>
                </template>
                <template
                  v-else-if="
                    props.items.length < 1 && !$apollo.queries.listNews.loading
                  "
                >
                  <tr>
                    <td :colspan="headerNews.length">
                      <v-alert type="error">
                        No data found
                      </v-alert>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- End NewsCard -->

    <!-- User Card -->
    <v-col cols="12">
      <v-card color="#6fbee2" dark elevation="5">
        <v-card-title class="headline font-weight-medium">Users</v-card-title>
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerUsers"
            :items="listUsers"
            :items-per-page="5"
            :loading="$apollo.queries.listUsers.loading"
          >
            <!-- Customizing headers user -->
            <template v-slot:header.no="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.id="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.userName="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.role="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.createdAt="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.fullName="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.email="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <!-- End customizing headers user -->

            <template v-slot:body="props">
              <tbody>
                <template v-if="props.items.length">
                  <tr v-for="user in props.items" :key="`user-${user.id}`">
                    <td
                      v-for="(header, i) in headerUsers"
                      :key="`headerUsers-${i}`"
                    >
                      {{ tdValue(user[header.field], header.field) }}
                    </td>
                  </tr>
                </template>
                <template
                  v-else-if="
                    props.items.length < 1 && !$apollo.queries.listUsers.loading
                  "
                >
                  <tr>
                    <td :colspan="headerUsers.length">
                      <v-alert type="error">
                        No data found
                      </v-alert>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- End User Card -->

    <!-- Role Card -->
    <v-col cols="12">
      <v-card color="#6fbee2" dark elevation="5">
        <v-card-title class="headline font-weight-medium">Role</v-card-title>
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerRoles"
            :items="listRoles"
            :items-per-page="5"
            :loading="$apollo.queries.listRoles.loading"
          >
            <!-- Customizing headers role -->
            <template v-slot:header.no="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.id="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.roleName="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:header.createdAt="{ header }">
              <span class="subtitle-2">
                {{ header.text }}
              </span>
            </template>
            <!-- End customizing headers role -->

            <template v-slot:body="props">
              <tbody>
                <template v-if="props.items.length">
                  <tr v-for="role in props.items" :key="`role-${role.id}`">
                    <td
                      v-for="(header, i) in headerRoles"
                      :key="`headerRoles-${i}`"
                    >
                      {{ tdValue(role[header.field], header.field) }}
                    </td>
                  </tr>
                </template>
                <template
                  v-else-if="
                    props.items.length < 1 && !$apollo.queries.listRoles.loading
                  "
                >
                  <tr>
                    <td :colspan="headerRoles.length">
                      <v-alert type="error">
                        No data found
                      </v-alert>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- End Role Card -->
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { users, news, roles } from "@/utils/graphqlQuery";
import moment from "moment";

export default {
  apollo: {
    listUsers: {
      query: users,
      update: (data) => {
        return data.users.map((item, i) => ({
          ...item,
          no: i + 1,
          role: item.role ? item.role.roleName : "-",
        }));
      },
    },
    listNews: {
      query: news,
      update: (data) => {
        return data.news.map((item, i) => ({
          ...item,
          no: i + 1,
          author: item.author ? item.author.userName : "-",
        }));
      },
    },
    listRoles: {
      query: roles,
      update: (data) => {
        return data.roles.map((item, i) => ({ ...item, no: i + 1 }));
      },
    },
  },
  components: {
    ContainerSlot,
  },
  data: () => ({
    headerUsers: [
      { text: "No", field: "no", value: "no" },
      { text: "ID", field: "id", value: "id" },
      { text: "Username", field: "userName", value: "userName" },
      { text: "Role", field: "role", value: "role" },
      { text: "Created At", field: "createdAt", value: "createdAt" },
      { text: "Fullname", field: "fullName", value: "fullName" },
      { text: "Email", field: "email", value: "email" },
    ],
    listUsers: [],
    headerNews: [
      { text: "No", field: "no", value: "no" },
      { text: "ID", field: "id", value: "id" },
      { text: "Title", field: "title", value: "title" },
      { text: "Created At", field: "createdAt", value: "createdAt" },
      { text: "Author", field: "author", value: "author" },
    ],
    listNews: [],
    headerRoles: [
      { text: "No", field: "no", value: "no" },
      { text: "ID", field: "id", value: "id" },
      { text: "Rolename", field: "roleName", value: "roleName" },
      { text: "Created At", field: "createdAt", value: "createdAt" },
    ],
    listRoles: [],
    skipQuery: true,
  }),
  methods: {
    tdValue(headerValue, headerName) {
      if (!headerValue) {
        return "-";
      }
      if (headerName == "createdAt" || headerName == "updatedAt") {
        return moment(new Date(headerValue)).format("DD/MM/YYYY HH:mm:ss");
      }
      return headerValue;
    },
  },
  name: "Dashboard",
  title() {
    return "Dashboard";
  },
};
</script>
<style scoped>
.head-table {
  color: #000000 !important;
}
</style>
